import { ReactComponent as AspectRatioInstaLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-insta-light.svg';
import { ReactComponent as AspectRatioInstagramPopover } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-insta-popover.svg';
import { ReactComponent as AspectRatioInstagram } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-insta.svg';
import { ReactComponent as AspectRatioLandscapeLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-landscape-popover-light.svg';
import { ReactComponent as AspectRatioLandscapePopover } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-landscape-popover.svg';
import { ReactComponent as AspectRatioLandscape } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-landscape.svg';
import { ReactComponent as AspectRatioMobileLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-mobile-light.svg';
import { ReactComponent as AspectRatioMobilePopover } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-mobile-popover.svg';
import { ReactComponent as AspectRatioMobile } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-mobile.svg';
import { ReactComponent as AspectRatioPortraitLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-portrait-popover-light.svg';
import { ReactComponent as AspectRatioPortraitPopover } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-portrait-popover.svg';
import { ReactComponent as AspectRatioPortrait } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-portrait.svg';

import { ReactComponent as AspectRatioSquareLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-square-popover-light.svg';

import { ReactComponent as AspectRatioSquarePopover } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-square-popover.svg';

import { ReactComponent as AspectRatioSquare } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-square.svg';
import { ReactComponent as AspectRatioTallLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-tall-light.svg';

import { ReactComponent as AspectRatioTall } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-tall.svg';
import { ReactComponent as AspectRatioWideLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-wide-light.svg';
import { ReactComponent as AspectRatioWide } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-wide.svg';
import { ReactComponent as AspectRatioWideScreenLight } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-widescreen-light.svg';
import { ReactComponent as AspectRatioWidescreenPopover } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-widescreen-popover.svg';
import { ReactComponent as AspectRatioWidescreen } from 'core/assets/svg/studio-tab/aspect-ratio-popover/aspect-ratio-widescreen.svg';

import { AspectRatio } from 'core/constants/enums/AspectRatioEnum.ts';
import React from 'react';

export const aspectRatioConfig = {
	[AspectRatio.INSTA]: {
		icon: <AspectRatioInstagram />,
		lightIcon: <AspectRatioInstaLight />,
		popoverIcon: <AspectRatioInstagramPopover />,
		label: '4:5',
		value: AspectRatio.INSTA,
		height: 512,
		width: 640,
		aspectRatio: 0.8,
	},
	[AspectRatio.PORTRAIT]: {
		icon: <AspectRatioPortrait />,
		lightIcon: <AspectRatioPortraitLight />,
		popoverIcon: <AspectRatioPortraitPopover />,
		label: '2:3',
		value: AspectRatio.PORTRAIT,
		height: 768,
		width: 512,
		aspectRatio: 2 / 3,
	},
	[AspectRatio.MOBILE]: {
		icon: <AspectRatioMobile />,
		lightIcon: <AspectRatioMobileLight />,
		popoverIcon: <AspectRatioMobilePopover />,
		label: '9:16',
		value: AspectRatio.MOBILE,
		height: 768,
		width: 432,
		aspectRatio: 9 / 16,
	},
	[AspectRatio.TALL]: {
		icon: <AspectRatioTall />,
		lightIcon: <AspectRatioTallLight />,
		popoverIcon: <AspectRatioTall />,
		label: '3:5',
		value: AspectRatio.TALL,
		height: 1280,
		width: 786,
		aspectRatio: 0.6,
	},
	[AspectRatio.SQUARE]: {
		icon: <AspectRatioSquare />,
		lightIcon: <AspectRatioSquareLight />,
		popoverIcon: <AspectRatioSquarePopover />,
		label: '1:1',
		value: AspectRatio.SQUARE,
		height: 512,
		width: 512,
		aspectRatio: 1,
	},
	[AspectRatio.LANDSCAPE]: {
		icon: <AspectRatioLandscape />,
		lightIcon: <AspectRatioLandscapeLight />,
		popoverIcon: <AspectRatioLandscapePopover />,
		label: '3:2',
		value: AspectRatio.LANDSCAPE,
		height: 512,
		width: 768,
		aspectRatio: 1.5,
	},
	[AspectRatio.WIDESCREEN]: {
		icon: <AspectRatioWidescreen />,
		lightIcon: <AspectRatioWideScreenLight />,
		popoverIcon: <AspectRatioWidescreenPopover />,
		label: '16:9',
		value: AspectRatio.WIDESCREEN,
		height: 432,
		width: 768,
		aspectRatio: 1.66,
	},
	[AspectRatio.WIDE]: {
		icon: <AspectRatioWide />,
		lightIcon: <AspectRatioWideLight />,
		popoverIcon: <AspectRatioWide />,
		label: '5:3',
		value: AspectRatio.WIDE,
		height: 786,
		width: 1280,
		aspectRatio: 5 / 3,
	},
};

export const aspectRatioFromLabel = Object.keys(aspectRatioConfig).reduce(
	(map, aspectRatioKey) => ({
		...map,
		[aspectRatioConfig[aspectRatioKey].label]: aspectRatioConfig[aspectRatioKey],
	}),
	{},
);
